var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChest = function SvgChest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M3.6 1A3.6 3.6 0 0 0 0 4.6v1.5h5.043c.727 0 1.333.513 1.47 1.2.1.732.728 1.3 1.487 1.3.746 0 1.364-.587 1.48-1.3h.003c.122-.706.737-1.3 1.478-1.3H16V4.6A3.6 3.6 0 0 0 12.4 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M4.407 7.8H0v5.4A1.8 1.8 0 0 0 1.8 15h12.4a1.8 1.8 0 0 0 1.8-1.8V7.8h-4.407a.55.55 0 0 0-.507.37A3.3 3.3 0 0 1 8 10.3a3.3 3.3 0 0 1-3.086-2.13.55.55 0 0 0-.507-.37"
  })));
};
export { SvgChest as ReactComponent };